var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 7.9987C9.84091 7.9987 11.3333 6.50631 11.3333 4.66536C11.3333 2.82442 9.84091 1.33203 7.99996 1.33203C6.15901 1.33203 4.66663 2.82442 4.66663 4.66536C4.66663 6.50631 6.15901 7.9987 7.99996 7.9987Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.93994 14.668C1.93994 11.908 4.65994 9.66797 7.99994 9.66797C11.3399 9.66797 14.0599 11.908 14.0599 14.668C14.0599 14.8546 13.9133 15.0013 13.7266 15.0013H2.27327C2.08661 15.0013 1.93994 14.8546 1.93994 14.668ZM9.19994 12.5C9.08948 12.5 8.99994 12.5895 8.99994 12.7V14.05C8.99994 14.1605 9.08948 14.25 9.19994 14.25H11.7999C11.9104 14.25 11.9999 14.1605 11.9999 14.05V12.7C11.9999 12.5895 11.9104 12.5 11.7999 12.5H9.19994Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoUser);
export default __webpack_public_path__ + "static/media/info_user.7980f0d1a585d4cf7e1a7de2e1c7bf8d.svg";
export { ForwardRef as ReactComponent };